import axiosInstance from "../../lib/axiosInstance";
import { AppDispatch } from "../store";
import { biActions } from "../slices/bi";
import { getErrorMessage } from "../../utils/errorUtils";
import { BiResponseDto } from "../../shared/dtos/bi/BiResponseDto";
import { BiInsightsQueryDto } from "../../shared/dtos/bi/BiInsightsQueryDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getBiInsights =
  (params?: BiInsightsQueryDto) => async (dispatch: AppDispatch) => {
    dispatch(biActions.setLoadingInsights());
    try {
      const { data } = await axiosInstance.get<ApiResponseDto<BiResponseDto>>(
        "/bi/insights",
        { headers: { requiresAuth: true }, params },
      );

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(biActions.setInsights(data.data.insights));
      }
    } catch (error) {
      dispatch(biActions.setErrorLoadingInsights(getErrorMessage(error)));
    }
  };
